import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_DAMAGED_LOST_EXPENSE,
  RESET_DELAYED_LUGGAGE_EXPENSE,
  RESET_COMPENSATION,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    claimForDamagedLostOrStolenLuggageTravelDocumentOrCash: 'false',
    claimForDelayLuggage: 'false',
    claimForPassportCreditCard: 'false',
    claimForTheftOfCash: 'false',
    claimForLuggageAndPersonalEffect: 'false',
    howItHappened: '',
    whereYouWereInRelationToTheItem: '',
    additional: '',
    claimingFor: {
      loss: null,
      theft: null,
      damage: null,
      delay: null,
    },
    whoDidYouReportThisTo: '',
    otherDescription: '',
    reportReferenceNumber: '',
    nameOfTransportProvider: '',
    dateLuggageDelay: '',
    timeLuggageDelay: null,
    dateLuggageReturn: '',
    timeLuggageReturn: null,
    paidForDelay: 'false',
    madeClaimWithTravelProviderOrOther: 'false',
    listedOnThePolicy: 'false',
    additionalItems: [],
    delayedLuggageExpenses: [],
    dateCompensationWasReceived: '',
    compensationDescription: '',
    amountOfCompensation: '',
    amountOfCompensationCurrency: '',
  },
  errors: [],
});

const initialDelayedLuggageExpenseState = {
  form: {
    claimForDelayLuggage: 'false',
    nameOfTransportProvider: '',
    dateLuggageDelay: '',
    timeLuggageDelay: null,
    dateLuggageReturn: '',
    timeLuggageReturn: null,
    paidForDelay: 'false',
    madeClaimWithTravelProviderOrOther: 'false',
    listedOnThePolicy: 'false',
    delayedLuggageExpenses: [],
    dateCompensationWasReceived: '',
    compensationDescription: '',
    amountOfCompensation: '',
    amountOfCompensationCurrency: '',
  },
};

const initialDamagedLostStolenExpenseState = {
  form: {
    claimForDamagedLostOrStolenLuggageTravelDocumentOrCash: 'false',
    claimForPassportCreditCard: 'false',
    claimForTheftOfCash: 'false',
    claimForLuggageAndPersonalEffect: 'true',
    howItHappened: '',
    whereYouWereInRelationToTheItem: '',
    additional: '',
    claimingFor: {
      loss: null,
      theft: null,
      damage: null,
      delay: null,
    },
    whoDidYouReportThisTo: '',
    otherDescription: '',
    reportReferenceNumber: '',
    additionalItems: [],
  },
};

const emptyCompensationExpense = {
  form: {
    amountOfCompensation: '',
    amountOfCompensationCurrency: '',
    dateCompensationWasReceived: '',
    compensationDescription: '',
  },
};

function step7Reducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_DAMAGED_LOST_EXPENSE:
      return state
        .setIn(['form', 'additionalItems'], [])
        .mergeDeep(initialDamagedLostStolenExpenseState);
    case RESET_DELAYED_LUGGAGE_EXPENSE:
      return state
        .setIn(['form', 'delayedLuggageExpenses'], [])
        .mergeDeep(initialDelayedLuggageExpenseState);
    case RESET_COMPENSATION:
      return state.mergeDeep(emptyCompensationExpense);
    default:
      return state;
  }
}

export default step7Reducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step7/reducer.js